import { render, staticRenderFns } from "./SupplierBankAccountsControl.vue?vue&type=template&id=46c7402a&"
import script from "./SupplierBankAccountsControl.vue?vue&type=script&lang=js&"
export * from "./SupplierBankAccountsControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports